import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';

import { DepartureCheckRoutingModule } from './departure-check-routing.module';
import { DepartureCheckDashboardComponent } from './departure-check-dashboard/departure-check-dashboard.component';
import { DepartureCheckWizardComponent } from './departure-check-wizard/departure-check-wizard.component';
import { DepartureCheckSummaryComponent } from './departure-check-summary/departure-check-summary.component';
import { VehicleDamageDiagramComponent } from './vehicle-damage-diagram/vehicle-damage-diagram.component';

@NgModule({
    declarations: [
        DepartureCheckDashboardComponent,
        DepartureCheckWizardComponent,
        DepartureCheckSummaryComponent,
        VehicleDamageDiagramComponent,
    ],
    imports: [
        CommonModule,
        DepartureCheckRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        BrowserAnimationsModule,
        NgxSpinnerModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DepartureCheckModule { }
